<template>
	<div class="message">
		<van-nav-bar fixed placeholder :title="$route.meta.title" left-arrow @click-left="onClickLeft"
			@click-right="onClickRight">
			<template #right>
				<div class="service">
					<van-icon name="service-o" size="18" />
					<div class="text">客服</div>
				</div>
			</template>
		</van-nav-bar>
		<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
			<van-empty description="暂无消息" class="custom-image"
				image="https://img01.yzcdn.cn/vant/custom-empty-image.png" v-if="!messages.length" />
			<div v-else class="item-message" v-for="(item, index) in messages" :key="index">
				<van-cell v-if="item.type === 'system'" title="系统通知" label="好房好价不等人" class="cell-message system">
					<template #title>
						<div class="append-date">
							<span>系统通知</span>
							<span>12-22</span>
						</div>
					</template>
					<template #icon>
						<div class="avatar van-cell__left-icon">
							<van-icon name="bullhorn-o" dot />
						</div>
					</template>
				</van-cell>
				<van-cell v-else icon="shop-o" class="cell-message" @click="onChat(item.chatId)">
					<template #icon>
						<div class="avatar van-cell__left-icon">
							<van-image cover round :class="`${item.isRead ? '' : 'dot'}`" :src="item.avatar" />
						</div>
					</template>
					<template #title>
						<div class="van-cell__label append-date">
							<span v-text="item.name"></span>
							<span v-text="item.date"></span>
						</div>
						<span v-text="item.text"></span>
						<div class="van-cell__label van-ellipsis" v-text="item.prompt"></div>
					</template>
				</van-cell>
			</div>
		</van-pull-refresh>
	</div>
</template>

<script>
	import request from "@/utils/request";
	import {
		showToast,
		NavBar as VanNavBar,
		Icon as VanIcon,
		Cell as VanCell,
		Image as VanImage,
		Empty as VanEmpty,
		PullRefresh as VanPullRefresh,
	} from "vant";

	export default {
		components: {
			VanNavBar,
			VanIcon,
			VanCell,
			VanImage,
			VanEmpty,
			VanPullRefresh,
		},
		data() {
			return {
				test: "",
				messages: [],
				isLoading: false,
			};
		},
		mounted() {

			if (this.$route.query.token) {
				localStorage.setItem("token", this.$route.query.token)
			}
			this.getMessages();
		},
		methods: {
			onRefresh() {
				this.getMessages().then(() => {
					this.isLoading = false;
				}).catch(() => {
					this.isLoading = false;
				});
			},
			onChat(chatId) {
				if (this.isWechat()) {
					wx.miniProgram.navigateTo({
						url: "/pages/info/chat?id=" + chatId
					});
				} else {
					this.$router.push({
						name: "message/chat",
						query: {
							chatId
						},
					});
				}
			},
			onClickRight() {
				showToast({
					type: "success",
					message: "按钮",
					duration: 2000,
				});
			},
			async getMessages() {
				try {
					const {
						data
					} = await request.get("", {
						params: {
							do: "Messages",
						},
					});
					this.messages = data;
				} catch (e) {
					console.log(e);
				}
			},
		},
	};
</script>

<style lang="less">
	.message {
		background: #f7f9fb;
		min-height: 100vh;

		.service {
			.text {
				font-family: PingFangSC-Regular;
				font-size: 10px;
				color: #666;
				letter-spacing: 0;
				line-height: 10px;
				font-weight: 400;
			}
		}

		.van-pull-refresh {
			min-height: calc(100vh);
		}

		.van-nav-bar__placeholder+.van-pull-refresh {
			min-height: calc(100vh - 46px);
		}

		.cell-message {
			margin-top: 10px;

			.append-date {
				display: flex;
				justify-content: space-between;
			}

			.append-date span:last-of-type {
				color: #969799;
				font-size: 12px;
			}

			.avatar {
				width: 46px;
				height: 68px;
				display: flex;
				align-items: center;
				justify-content: center;

				i {
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: 22px;
					background: #2fd5cd;
					color: #fff;
					border-radius: 100%;
					width: 36px;
					height: 36px;
				}
			}

			.dot {
				position: relative;

				&::after {
					position: absolute;
					content: " ";
					top: -7px;
					display: block;
					width: 6px;
					min-width: 0;
					height: 6px;
					background-color: #ee0a24;
					border-radius: 100%;
					right: 2px;
				}
			}

			.dot.van-image--round {
				overflow: visible;
			}

			.van-cell__label {
				width: calc(100vw - 78px);
			}
		}

		.system {
			.avatar {
				height: 46px;
			}
		}

		.custom-image {
			padding-top: 20vh;

			.van-empty__image {
				width: 90px;
				height: 90px;
			}
		}
	}
</style>